import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { IPosthogProperties } from '../constants/posthog.constant';
import { IFormEventsData } from '../constants';

@Injectable({
  providedIn:'root',
})
export class PosthogService {
  hasFired = false;
  hostname = (<any>window).location.hostname;
  posthog;

  get isProd() {
    return this.hostname?.includes('dashboard.xilo.io') || this.hostname?.includes('intake.xilo.io') || this.hostname?.includes('forms.xilo.io');
  }

  constructor() {
    this.posthog = (<any>window)['posthog'];
  }

  captureDashboardEvent(eventName: string, properties?: IPosthogProperties) {
    if (this.isProd && typeof this.posthog !== 'undefined') {
      this.posthog.capture(eventName, properties);
      this.captureTotangoEvent(
        properties.company_id,
        properties.email,
        eventName,
        properties
      );
    }
  }

  captureTotangoEvent(
    companyId: number,
    email: string,
    event: string,
    properties: IPosthogProperties
  ) {
    const eventHash = {
      'Updated Form': {
        a: 'Updated Form',
        m: 'Form Builder',
      },
      'Edited Form': {
        a: 'Edited Form',
        m: 'Form Builder',
      },
      'Added Prospect': {
        a: 'Added Prospect',
        m: 'Dashboard',
      },
      'Viewed In Vendor': {
        a: 'Viewed In Vendor',
        m: 'Dashboard',
      },
      'Shared Form': {
        a: 'Shared Form',
        m: 'Form List',
      },
      'Shared Script': {
        a: 'Shared Script',
        m: 'Form List',
      },
      'Form Created': {
        a: 'Form Created',
        m: 'Form Wizard',
      },
      'Form Wizard Cancelled': {
        a: 'Form Wizard Cancelled',
        m: 'Form Wizard',
      },
      'New Form Failed': {
        a: 'New Form Failed',
        m: 'Form Wizard',
      },
      'New Form Passed Test': {
        a: 'New Form Passed Test',
        m: 'Form Wizard',
      },
      login: {
        a: 'Login',
        m: 'Dashboard',
      },
      'Lifecycle Change': {
        a: 'Lifecycle Change',
        m: 'Dashboard',
      },
      'Completed Signup Flow': {
        a: 'Completed Signup Flow',
        m: 'Signup Flow',
      },
      'Account Created': {
        a: 'Account Created',
        m: 'Signup Flow',
      },
      'Password Created': {
        a: 'Password Created',
        m: 'Signup Flow',
      },
      'Customer Support': {
        a: 'Customer Support',
        m: 'Dashboard',
      },
      'Added Team': {
        a: 'Added Team',
        m: 'Settings',
      },
    };
    const a = get(eventHash, `${event}.a`) || event;
    const m = get(eventHash, `${event}.m`) || properties.source;
    if (!a || !m) return;
    let totangoUrl = 'https://sdr.totango.com/pixel.gif/?sdr_s=SP-237356-01';
    totangoUrl += `&sdr_o=${companyId}&sdr_a=${a}&sdr_m=${m}`;
    if (email) totangoUrl += `&sdr_u=${email}`;
    // Create an image element
    const img = new Image();

    // Set the src to the URL
    img.src = totangoUrl;

    // Optionally, you can add event listeners if needed
    img.onload = () => console.log('Image loaded');
    img.onerror = () => console.log('Error loading image');

    // Append the image to the body or another container element
    document.body.appendChild(img);
  }

  captureEvent(eventName: any, properties?: any) {
    if (!this.hasFired && this.posthog !== 'undefined' && this.isProd) {
      let obj = eventName;
      if (properties) {
        obj = { event: eventName, properties: properties };
      }
      this.posthog.capture(obj);
      this.hasFired = true;
    }
  }

  captureFormEvent(formEvent: IFormEventsData) {
    try {
      if (!this.isProd || !this.posthog) return console.log(`Event: ${formEvent.name} triggered but did not fire`);
      const { name, companyId, companyName, formId, formTitle, clientId, source } = formEvent;
      if (!clientId || !companyId) return console.log(`Event: ${name} triggered but is missing key details`);
      this.posthog.identify(clientId);
      this.posthog.group('company', companyId, { company_name: companyName });
      this.posthog.capture(name, {
        company_id: companyId,
        company_name: companyName,
        form_id: formId,
        form_title: formTitle,
        source
      });
      if (typeof parent !== 'undefined' && parent) parent.postMessage(name, '*');
    } catch (error) {
      console.log('Error logging posthog event: ', error);
    }
  }
}
